export default __webpack_public_path__ + "static/media/image12.92b4205a.jpg";